// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__3LxQJ","lastUpdated":"PrivacyPolicy_lastUpdated__3GHl-"};